<template>
  <modal-base v-model:show="showModal">
    <div class="">
      <!-- <div class="relative" style="width: 40%;">
        <img src="../assets/certificado.png" class="inline-block relative" style="z-index: 2; transform: rotate(-9deg); margin-left: -25px; margin-top: -42px;" />
        <div class="absolute" style="width: 100%; left: -175px; top: 0; z-index: 1;">
          <img src="../assets/raio.png" class="raio raio1" />
          <img src="../assets/raio.png" class="raio raio2" />
          <img src="../assets/raio.png" class="raio raio3" />
          <img src="../assets/raio.png" class="raio raio4" />
          <img src="../assets/raio.png" class="raio raio5" />
          <img src="../assets/raio.png" class="raio raio6" />
        </div>
      </div> -->
      <div class="inline-block pl-10 message-container">
        <template v-if="passou()">
          <h2>Parabéns!</h2>
          <p>Você conquistou a medalha de Agente de Prevenção da Rede SARAH! Agora você sabe mais sobre como <b>PREVENIR</b> acidentes, e pode compartilhar esse conhecimento com seus amigos e familiares! Você Conseguiu!</p>
        </template>
        <template v-else>
          <h2>Ooops!</h2>
          <p>Você está quase lá, clique no botão abaixo e tente novamente!</p>
        </template>
      </div>
    </div>
    <hr class="mt-5" style="border-top: 1px solid #868686" />
    <div v-if="passou()">
      <h2 style="font-size: 2rem !important">Você conseguiu!</h2>
      <div>
        <button class="rounded-lg bg-red px-6 py-4 text-white btn-resultado" type="button" @click="openContent('CERTIFICADO.pdf')">Baixe seu certificado aqui!</button>
      </div>
      <button class="px-6 py-4" @click="showModal = false">Fechar</button>
    </div>
    <div v-else>
      <h2 style="font-size: 2rem !important">Quase lá!</h2>
      <button class="rounded-lg bg-red px-6 py-4 text-white btn-resultado" @click="tenteNovamente()">Tente novamente</button>
    </div>
    <!-- <div>
      <h2 style="font-size: 2rem !important">Cadastre-se para receber seu certificado!</h2>
      <button class="rounded-lg bg-red px-6 py-4 text-white" style="background-color: #F69E36; border-radius: 50px" @click="showModal = false">Cadastrar</button>
    </div> -->
  </modal-base>
</template>

<script>
import ModalBase from './common/ModalBase.vue'
export default {
  components: { ModalBase },
  props: ['show','qtdAcertos'],
  computed: {
    showModal: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('update:show', value)
      }
    }
  },
  methods: {
    passou() {
      return this.qtdAcertos >= 4
    },
    tenteNovamente() {
      this.showModal = false
      this.$emit('TENTE_NOVAMENTE')
    },
    openContent(file) {
      window.open(window.location.origin + window.location.pathname + file, '_blank')
    },
  }
}
</script>

<style>
.raio {
  position: absolute;
  z-index: 1;
}
.raio1 {
  margin-left: -125px;
  margin-top: 48px;
  transform: rotate(-60deg);
}
.raio2 {
  margin-left: -95px;
  margin-top: -21px;
  transform: rotate(312deg) scale(0.7);
}
.raio3 {
  margin-left: -47px;
  margin-top: -146px;
}
.raio4 {
  margin-left: 150px;
  margin-top: -147px;
  transform: rotate(21deg);
}
.raio5 {
  margin-left: 240px;
  margin-top: -177px;
  transform: rotate(54deg) skew(10deg, 10deg);
}
.raio6 {
  margin-left: 269px;
  margin-top: -107px;
  transform: rotate(80deg) skew(9deg, 15deg);
}

.message-container {
  width: 60%;
}

.btn-resultado {
  background-color: #F69E36;
  border-radius: 50px;
  margin-top: 20px;
}

@media (max-width: 767px) {
  .message-container {
    width: 100%;
  }
}
</style>